// import { Calendar, ChevronDown, MapPin, Users, Video } from "lucide-react";
// import React, { useRef, useState } from "react";

// const Events = () => {
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [selectedDate, setSelectedDate] = useState(null);

//   const eventDetailsRef = useRef(null);

//   // EVENT Sections with added URLs
//   const events = [
//     {
//       id: 1,
//       title: "Capacity Building Workshop",
//       date: new Date("2025-01-15"),
//       location: "Online Platform",
//       description:
//         "Enhance skills in leadership, project management, and entrepreneurship for Gambian students.",
//       image: "https://i.ibb.co/SxJhtV9/first-webinar.jpg",
//       color: "bg-green-500",
//       type: "offline",
//       url: ''
//     },
//     {
//       id: 1,
//       title: "Capacity Building Workshop",
//       date: new Date("2024-07-10"),
//       location: "Online Platform",
//       description:
//         "Enhance skills in leadership, project management, and entrepreneurship for Gambian students.",
//       image: "https://i.ibb.co/SxJhtV9/first-webinar.jpg",
//       color: "bg-green-500",
//       type: "online",
//     },
//     {
//       id: 2,
//       title: "Annual General Meeting",
//       date: new Date("2024-09-20"),
//       location: "College of Engineering AU",
//       description:
//         "Discuss the association's progress, elect new leadership, and plan for the upcoming year.",
//       image: "https://i.ibb.co/MGPTks5/mr-kanyi-webinar.jpg",
//       color: "bg-green-500",
//       type: "online",
//     },
//     {
//       id: 3,
//       title: "Inter-State Debate Championship",
//       date: new Date("2024-10-11"),
//       location: "Google Meet",
//       description:
//         "Different Gambian student across all many states gather in one platform to debate on topics that are relevants.",
//       image: "https://i.ibb.co/PFDkF99/Debate-24.jpg",
//       color: "bg-red-500",
//       type: "online",
//     },
//     {
//       id: 4,
//       title: "Haryana vs Andhra Pradesh",
//       date: new Date("2024-10-12"),
//       location: "Google meet",
//       description: "This house believes that Jammeh should be granted amnesty",
//       image: "https://i.ibb.co/dL0FCrx/Haryana-vs-Andhra.jpg",
//       color: "bg-blue-500",
//       type: "online",
//     },
//     {
//       id: 5,
//       title: "Maharasthra vs Delhi",
//       date: new Date("2024-10-12"),
//       location: "Google meet",
//       description:
//         "This house believes that Gambians in the diaspora should be allowed to vote",
//       image: "https://i.ibb.co/2KyQd6d/Maharasthra-vs-Delhi.jpg",
//       color: "bg-orange-500",
//       type: "online",
//     },
//     {
//       id: 6,
//       title: "Madya Pradesh vs Punjab",
//       date: new Date("2024-10-13"),
//       location: "Google meet",
//       description: "This will ban Rice Importation in The Gambia",
//       image: "https://i.ibb.co/KwTv2Bv/Madyana-vs-Punjab.jpg",
//       color: "bg-yellow-500",
//       type: "online",
//     },

//     {
//       id: 7,
//       title: "Maharastra vs Andhra Pradesh",
//       date: new Date("2024-10-19"),
//       location: "Google meet",
//       description:
//         "This house will reintroduce the death penalty in The Gambia",
//       image: "https://i.ibb.co/PN9CCyZ/maharastra-vs-andra.jpg",
//       color: "bg-pink-500",
//       type: "online",
//     },
//     {
//       id: 8,
//       title: "Madya Pradesh vs Delhi",
//       date: new Date("2024-10-19"),
//       location: "Google meet",
//       description:
//         "This house blames the current regime for the increase in crimes in The Gambia",
//       image: "https://i.ibb.co/hckB2dj/Delhi-vs-Haryana.jpg",
//       color: "bg-yellow-500",
//       type: "online",
//     },
//     {
//       id: 9,
//       title: "Madhya Pradesh vs Andhra Pradesh",
//       date: new Date("2024-10-27"),
//       location: "Google meet",
//       description:
//         "This house blames the Regional Education Directorates for the Delayed disbursements of school Improvement Grant (SIG)",
//       image: "https://i.ibb.co/CHjrySH/Andhra-vs-Madya.jpg",
//       color: "bg-purple-500",
//       type: "online",
//     },
//     {
//       id: 10,
//       title: "Punjab vs Gujarat",
//       date: new Date("2024-11-02"),
//       location: "Google meet",
//       description:
//         "This house believes that, the Illegal migration is cause by weak Educational system in The Gambia",
//       image: "https://i.ibb.co/8Ky1GjH/Punjab-vs-Gujarat.jpg",
//       color: "bg-blue-500",
//       type: "online",
//     },
//     {
//       id: 11,
//       title: "GAM-IND Online Activities Finals",
//       date: new Date("2024-11-01"),
//       location: "Google meet",
//       description:
//         "The FINAL for Ludo Championship, E-Football Championship, Chess Championship, And Push-Up Challenge",
//       image: "https://i.ibb.co/7Srd4Gj/Gamind-online-activities-finals.jpg",
//       color: "bg-green-500",
//       type: "online",
//     },
//     {
//       id: 15,
//       title: "Gambia's Independence Celebration Day",
//       date: new Date("2025-02-18"),
//       location: "Mahatma Gandhi Mission (MGM)",
//       description:
//         "Commemorate Gambian independence with cultural performances, food, and guest speakers.",
//       image: "https://i.ibb.co/MGPTks5/mr-kanyi-webinar.jpg",
//       color: "bg-yellow-500",
//       type: "offline",
//       url: "https://docs.google.com/forms/d/e/1FAIpQLSfknFS-Q9MPIMmLyGG0TTpyBQifi45UBaw3hZ_azW2-ziGWtg/viewform?usp=header",
//     },

//     {
//       id: 16,
//       title: "Invitation to the Presentation of the First Quarterly Report",
//       // date: new Date("2024-11-03"),
//       date: new Date("2025-02-13"),

//       location: "Yet to Finalize",
//       description:
//         "The 8th Executive Council invites you to our first quarterly report presentation, where we'll showcase our achievements and future plans - your presence will help shape our association's path forward. 📊✨",
//       image: "https://i.ibb.co/jgwgWWT/first-quaterly-report.jpg",
//       color: "bg-red-600",
//       type: "online",
//       // url: '',
//       url: "https://docs.google.com/forms/d/e/1FAIpQLSfknFS-Q9MPIMmLyGG0TTpyBQifi45UBaw3hZ_azW2-ziGWtg/viewform?usp=header",
//     },
//     {
//       id: 16,
//       title: "Invitation to the Presentation of the First Quarterly Report",
//       date: new Date("2025-01-04"),
//       location: "Google Meet",
//       description:
//         "Gam-Ind monthly webinar with Dr. Ismail D. Badjie",
//       image: "https://i.ibb.co/5kkVwyM/webinar-Ismail-badgie.jpg",
//       color: "bg-red-600",
//       type: "online",
//       url: "https://meet.google.com/mui-tuke-dkd",
//     },
//   ];

//   const years = Array.from(
//     { length: 10 },
//     (_, i) => new Date().getFullYear() - 2 + i
//   );
//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const getDaysInMonth = (year, month) =>
//     new Date(year, month + 1, 0).getDate();
//   const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

//   const generateCalendarDays = (year, month) => {
//     const daysInMonth = getDaysInMonth(year, month);
//     const firstDayOfMonth = getFirstDayOfMonth(year, month);
//     const calendarDays = [];

//     for (let i = 0; i < firstDayOfMonth; i++) {
//       calendarDays.push(null);
//     }

//     for (let i = 1; i <= daysInMonth; i++) {
//       calendarDays.push(new Date(year, month, i));
//     }

//     return calendarDays;
//   };

//   const calendarDays = generateCalendarDays(
//     currentDate.getFullYear(),
//     currentDate.getMonth()
//   );

//   const handleYearChange = (e) => {
//     setCurrentDate(
//       new Date(parseInt(e.target.value), currentDate.getMonth(), 1)
//     );
//   };

//   const handleMonthChange = (e) => {
//     setCurrentDate(
//       new Date(currentDate.getFullYear(), parseInt(e.target.value), 1)
//     );
//   };

//   const getEventsForDate = (date) => {
//     return events.filter(
//       (event) => event.date.toDateString() === date.toDateString()
//     );
//   };

//   const formatDate = (date) => {
//     return date.toLocaleDateString("en-US", {
//       weekday: "long",
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//   };

//   const handleEventAction = (event) => {
//     if (event.url) {
//       window.open(event.url, "_blank", "noopener,noreferrer");
//     }
//   };

//   const handleDateSelection = (date) => {
//     setSelectedDate(date);
//     if (eventDetailsRef.current) {
//       eventDetailsRef.current.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   return (
//     <div className="bg-gray-100 min-h-screen">
//       {/* Hero Section */}
//       <div className="relative h-80 bg-cover bg-center flex flex-col justify-center items-center text-white text-center mb-4">
//         <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-green-600 opacity-90"></div>
//         <div className="relative z-10 px-4">
//           <h1 className="text-4xl md:text-5xl font-bold mb-4">
//             GAM-IND Events Calendar
//           </h1>
//           <p className="text-lg md:text-xl max-w-2xl">
//             Join the Association of Gambian Students in India (GAM-IND) for our
//             exciting events throughout the year. Together, we build capacity,
//             promote cultural exchange, and empower Gambian students in India.
//           </p>
//         </div>
//       </div>

//       {/* Calendar Section */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
//           <div className="flex flex-col p-6 border-b">
//             <div className="flex flex-col md:flex-row items-center justify-between mb-2">
//               <div className="flex flex-col">
//                 <h2 className="text-2xl font-semibold">
//                   GAM-IND Events Calendar
//                 </h2>
//                 <p className="text-md text-gray-600 mt-1">
//                   Click on any date with colored dots to view event details for
//                   that day.
//                 </p>
//               </div>

//               <div className="flex items-center space-x-4 mt-4 md:mt-0">
//                 <div className="relative">
//                   <select
//                     value={currentDate.getFullYear()}
//                     onChange={handleYearChange}
//                     className="appearance-none bg-white border border-gray-300 rounded-md pl-3 pr-8 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
//                   >
//                     {years.map((year) => (
//                       <option key={year} value={year}>
//                         {year}
//                       </option>
//                     ))}
//                   </select>
//                   <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
//                 </div>

//                 <div className="relative">
//                   <select
//                     value={currentDate.getMonth()}
//                     onChange={handleMonthChange}
//                     className="appearance-none bg-white border border-gray-300 rounded-md pl-3 pr-8 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
//                   >
//                     {months.map((month, index) => (
//                       <option key={month} value={index}>
//                         {month.slice(0, 3)}
//                       </option>
//                     ))}
//                   </select>
//                   <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="p-6">
//             {/* Grid for Calendar Days */}
//             <div className="grid grid-cols-7 gap-2 mb-2">
//               {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
//                 <div
//                   key={day}
//                   className="text-center font-medium text-gray-500"
//                 >
//                   {day}
//                 </div>
//               ))}
//             </div>
//             <div className="grid grid-cols-7 gap-2">
//               {calendarDays.map((day, index) => {
//                 if (!day)
//                   return (
//                     <div key={`empty-${index}`} className="min-h-16"></div>
//                   );
//                 const dayEvents = getEventsForDate(day);
//                 return (
//                   <div
//                     key={day.toString()}
//                     className={`min-h-16 p-2 border rounded-sm flex flex-col justify-between ${
//                       dayEvents.length > 0
//                         ? "cursor-pointer hover:bg-gray-200 transition-colors bg-gray-100"
//                         : "bg-white"
//                     } ${
//                       selectedDate &&
//                       selectedDate.toDateString() === day.toDateString()
//                         ? "ring-1 ring-blue-500"
//                         : ""
//                     }`}
//                     onClick={() => handleDateSelection(day)}
//                   >
//                     <div className="text-right font-medium">
//                       {day.getDate()}
//                     </div>
//                     {dayEvents.length > 0 && (
//                       <div className="mt-1 flex flex-wrap gap-1 justify-center">
//                         {dayEvents.slice(0, 3).map((event) => (
//                           <div
//                             key={event.id}
//                             className={`w-2 h-2 rounded-full ${event.color}`}
//                             title={event.title}
//                           ></div>
//                         ))}
//                         {dayEvents.length > 3 && (
//                           <div className="text-xs text-gray-500">
//                             +{dayEvents.length - 3}
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>

//         {/* Event Details */}
//         {selectedDate && (
//           <div
//             ref={eventDetailsRef}
//             className="bg-white rounded-md shadow-sm overflow-hidden mb-6"
//           >
//             <div className="p-6 border-b">
//               <h3 className="text-xl font-semibold">
//                 Events on {formatDate(selectedDate)}
//               </h3>
//             </div>
//             <div className="p-6">
//               {getEventsForDate(selectedDate).length === 0 ? (
//                 <p className="text-gray-500">
//                   No events scheduled for this date.
//                 </p>
//               ) : (
//                 <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
//                   {getEventsForDate(selectedDate).map((event) => (
//                     <div
//                       key={event.id}
//                       className={`relative rounded-lg overflow-hidden shadow-lg transform transition-transform border-l-4 mx-auto sm:w-11/12 md:w-full ${
//                         event.type === "online"
//                           ? "border-green-500"
//                           : "border-blue-500"
//                       }`}
//                       style={{
//                         background:
//                           event.type === "online"
//                             ? "linear-gradient(135deg, #e0f2f1, #a5d6a7)"
//                             : "linear-gradient(135deg, #e3f2fd, #90caf9)",
//                       }}
//                     >
//                       <div className="w-full h-64 overflow-hidden relative">
//                         <img
//                           src={event.image}
//                           alt={event.title}
//                           className="w-full h-full object-cover object-top rounded-t-lg"
//                         />
//                         <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black via-transparent opacity-30 rounded-t-lg"></div>
//                       </div>

//                       <div className="p-4">
//                         <h4 className="text-lg font-semibold text-gray-800 mb-2">
//                           {event.title}
//                         </h4>
//                         <div className="flex items-center mb-2 text-sm text-gray-600">
//                           <Calendar className="w-4 h-4 mr-2" />
//                           <span>{formatDate(event.date)}</span>
//                         </div>
//                         <div className="flex items-center mb-2 text-sm text-gray-600">
//                           {event.type === "online" ? (
//                             <Video className="w-4 h-4 mr-2" />
//                           ) : (
//                             <MapPin className="w-4 h-4 mr-2" />
//                           )}
//                           <span>{event.location}</span>
//                         </div>
//                         <p className="text-sm text-gray-700 mb-4">
//                           {event.description}
//                         </p>

//                         <button
//                           onClick={() => handleEventAction(event)}
//                           className={`w-full px-4 py-2 rounded-full text-white font-bold flex items-center justify-center transition-colors ${
//                             event.type === "online"
//                               ? "bg-green-500 hover:bg-green-600"
//                               : "bg-blue-500 hover:bg-blue-600"
//                           } ${
//                             event.url
//                               ? "cursor-pointer"
//                               : "cursor-not-allowed opacity-50"
//                           }`}
//                           disabled={!event.url}
//                         >
//                           {event.type === "online" ? (
//                             <>
//                               <Video className="w-4 h-4 mr-2" />
//                               Join Now
//                             </>
//                           ) : (
//                             <>
//                               <Users className="w-4 h-4 mr-2" />
//                               Register Now
//                             </>
//                           )}
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Events;

import {
  Calendar,
  ChevronDown,
  MapPin,
  Users,
  Video,
  XCircle,
} from "lucide-react";
import React, { useRef, useState } from "react";

const Events = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);

  const eventDetailsRef = useRef(null);

  // EVENT Sections with added URLs
  const events = [
    {
      id: 1,
      title: "Capacity Building Workshop",
      date: new Date("2025-01-15"),
      location: "Online Platform",
      description:
        "Enhance skills in leadership, project management, and entrepreneurship for Gambian students.",
      image: "https://i.ibb.co/SxJhtV9/first-webinar.jpg",
      color: "bg-green-500",
      type: "offline",
      url: "",
    },
    {
      id: 1,
      title: "Capacity Building Workshop",
      date: new Date("2024-07-10"),
      location: "Online Platform",
      description:
        "Enhance skills in leadership, project management, and entrepreneurship for Gambian students.",
      image: "https://i.ibb.co/SxJhtV9/first-webinar.jpg",
      color: "bg-green-500",
      type: "online",
    },
    {
      id: 2,
      title: "Annual General Meeting",
      date: new Date("2024-09-20"),
      location: "College of Engineering AU",
      description:
        "Discuss the association's progress, elect new leadership, and plan for the upcoming year.",
      image: "https://i.ibb.co/MGPTks5/mr-kanyi-webinar.jpg",
      color: "bg-green-500",
      type: "online",
    },
    {
      id: 3,
      title: "Inter-State Debate Championship",
      date: new Date("2024-10-11"),
      location: "Google Meet",
      description:
        "Different Gambian student across all many states gather in one platform to debate on topics that are relevants.",
      image: "https://i.ibb.co/PFDkF99/Debate-24.jpg",
      color: "bg-red-500",
      type: "online",
    },
    {
      id: 4,
      title: "Haryana vs Andhra Pradesh",
      date: new Date("2024-10-12"),
      location: "Google meet",
      description: "This house believes that Jammeh should be granted amnesty",
      image: "https://i.ibb.co/dL0FCrx/Haryana-vs-Andhra.jpg",
      color: "bg-blue-500",
      type: "online",
    },
    {
      id: 5,
      title: "Maharasthra vs Delhi",
      date: new Date("2024-10-12"),
      location: "Google meet",
      description:
        "This house believes that Gambians in the diaspora should be allowed to vote",
      image: "https://i.ibb.co/2KyQd6d/Maharasthra-vs-Delhi.jpg",
      color: "bg-orange-500",
      type: "online",
    },
    {
      id: 6,
      title: "Madya Pradesh vs Punjab",
      date: new Date("2024-10-13"),
      location: "Google meet",
      description: "This will ban Rice Importation in The Gambia",
      image: "https://i.ibb.co/KwTv2Bv/Madyana-vs-Punjab.jpg",
      color: "bg-yellow-500",
      type: "online",
    },

    {
      id: 7,
      title: "Maharastra vs Andhra Pradesh",
      date: new Date("2024-10-19"),
      location: "Google meet",
      description:
        "This house will reintroduce the death penalty in The Gambia",
      image: "https://i.ibb.co/PN9CCyZ/maharastra-vs-andra.jpg",
      color: "bg-pink-500",
      type: "online",
    },
    {
      id: 8,
      title: "Madya Pradesh vs Delhi",
      date: new Date("2024-10-19"),
      location: "Google meet",
      description:
        "This house blames the current regime for the increase in crimes in The Gambia",
      image: "https://i.ibb.co/hckB2dj/Delhi-vs-Haryana.jpg",
      color: "bg-yellow-500",
      type: "online",
    },
    {
      id: 9,
      title: "Madhya Pradesh vs Andhra Pradesh",
      date: new Date("2024-10-27"),
      location: "Google meet",
      description:
        "This house blames the Regional Education Directorates for the Delayed disbursements of school Improvement Grant (SIG)",
      image: "https://i.ibb.co/CHjrySH/Andhra-vs-Madya.jpg",
      color: "bg-purple-500",
      type: "online",
    },
    {
      id: 10,
      title: "Punjab vs Gujarat",
      date: new Date("2024-11-02"),
      location: "Google meet",
      description:
        "This house believes that, the Illegal migration is cause by weak Educational system in The Gambia",
      image: "https://i.ibb.co/8Ky1GjH/Punjab-vs-Gujarat.jpg",
      color: "bg-blue-500",
      type: "online",
    },
    {
      id: 11,
      title: "GAM-IND Online Activities Finals",
      date: new Date("2024-11-01"),
      location: "Google meet",
      description:
        "The FINAL for Ludo Championship, E-Football Championship, Chess Championship, And Push-Up Challenge",
      image: "https://i.ibb.co/7Srd4Gj/Gamind-online-activities-finals.jpg",
      color: "bg-green-500",
      type: "online",
    },
    {
      id: 15,
      title: "Gambia's Independence Celebration Day",
      date: new Date("2025-02-18"),
      location: "Mahatma Gandhi Mission (MGM)",
      description:
        "Commemorate Gambian independence with cultural performances, food, and guest speakers.",
      image: "https://i.ibb.co/MGPTks5/mr-kanyi-webinar.jpg",
      color: "bg-yellow-500",
      type: "offline",
      url: "https://docs.google.com/forms/d/e/1FAIpQLSfknFS-Q9MPIMmLyGG0TTpyBQifi45UBaw3hZ_azW2-ziGWtg/viewform?usp=header",
    },

    {
      id: 16,
      title: "Invitation to the Presentation of the First Quarterly Report",
      date: new Date("2024-11-03"),
      location: "Yet to Finalize",
      description:
        "The 8th Executive Council invites you to our first quarterly report presentation, where we'll showcase our achievements and future plans - your presence will help shape our association's path forward. 📊✨",
      image: "https://i.ibb.co/jgwgWWT/first-quaterly-report.jpg",
      color: "bg-red-600",
      type: "online",
      // url: '',
      url: "https://docs.google.com/forms/d/e/1FAIpQLSfknFS-Q9MPIMmLyGG0TTpyBQifi45UBaw3hZ_azW2-ziGWtg/viewform?usp=header",
    },
    {
      id: 16,
      title: "Invitation to the Presentation of the First Quarterly Report",
      date: new Date("2025-01-04"),
      location: "Google Meet",
      description: "Gam-Ind monthly webinar with Dr. Ismail D. Badjie",
      image: "https://i.ibb.co/5kkVwyM/webinar-Ismail-badgie.jpg",
      color: "bg-red-600",
      type: "online",
      url: "https://meet.google.com/mui-tuke-dkd",
    },
  ];

  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - 2 + i
  );
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const isEventPassed = (event) => {
    const now = new Date();
    const deadline = event.registrationDeadline || new Date(event.date);
    return now > deadline;
  };

  const getEventStatus = (event) => {
    if (isEventPassed(event)) {
      return {
        isPassed: true,
        message:
          event.type === "online"
            ? "This event has already taken place"
            : "Registration deadline has passed",
        buttonText: "Event Ended",
        icon: XCircle,
      };
    }
    return {
      isPassed: false,
      message: "",
      buttonText: event.type === "online" ? "Join Now" : "Register Now",
      icon: event.type === "online" ? Video : Users,
    };
  };

  const getDaysInMonth = (year, month) =>
    new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

  const generateCalendarDays = (year, month) => {
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);
    const calendarDays = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      calendarDays.push(null);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      calendarDays.push(new Date(year, month, i));
    }

    return calendarDays;
  };

  const calendarDays = generateCalendarDays(
    currentDate.getFullYear(),
    currentDate.getMonth()
  );

  const handleYearChange = (e) => {
    setCurrentDate(
      new Date(parseInt(e.target.value), currentDate.getMonth(), 1)
    );
  };

  const handleMonthChange = (e) => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), parseInt(e.target.value), 1)
    );
  };

  const getEventsForDate = (date) => {
    return events.filter(
      (event) => event.date.toDateString() === date.toDateString()
    );
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleEventAction = (event) => {
    if (!isEventPassed(event) && event.url) {
      window.open(event.url, "_blank", "noopener,noreferrer");
    }
  };

  const handleDateSelection = (date) => {
    setSelectedDate(date);
    if (eventDetailsRef.current) {
      eventDetailsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Hero Section */}
      <div className="relative h-80 bg-cover bg-center flex flex-col justify-center items-center text-white text-center mb-4">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-green-600 opacity-90"></div>
        <div className="relative z-10 px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            GAM-IND Events Calendar
          </h1>
          <p className="text-lg md:text-xl max-w-2xl">
            Join the Association of Gambian Students in India (GAM-IND) for our
            exciting events throughout the year. Together, we build capacity,
            promote cultural exchange, and empower Gambian students in India.
          </p>
        </div>
      </div>

      {/* Calendar Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
          <div className="flex flex-col p-6 border-b">
            <div className="flex flex-col md:flex-row items-center justify-between mb-2">
              <div className="flex flex-col">
                <h2 className="text-2xl font-semibold">
                  GAM-IND Events Calendar
                </h2>
                <p className="text-md text-gray-600 mt-1">
                  Click on any date with colored dots to view event details for
                  that day.
                </p>
              </div>

              <div className="flex items-center space-x-4 mt-4 md:mt-0">
                <div className="relative">
                  <select
                    value={currentDate.getFullYear()}
                    onChange={handleYearChange}
                    className="appearance-none bg-white border border-gray-300 rounded-md pl-3 pr-8 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
                </div>

                <div className="relative">
                  <select
                    value={currentDate.getMonth()}
                    onChange={handleMonthChange}
                    className="appearance-none bg-white border border-gray-300 rounded-md pl-3 pr-8 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {months.map((month, index) => (
                      <option key={month} value={index}>
                        {month.slice(0, 3)}
                      </option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
                </div>
              </div>
            </div>
          </div>

          <div className="p-6">
            {/* Grid for Calendar Days */}
            <div className="grid grid-cols-7 gap-2 mb-2">
              {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                <div
                  key={day}
                  className="text-center font-medium text-gray-500"
                >
                  {day}
                </div>
              ))}
            </div>
            <div className="grid grid-cols-7 gap-2">
              {calendarDays.map((day, index) => {
                if (!day)
                  return (
                    <div key={`empty-${index}`} className="min-h-16"></div>
                  );
                const dayEvents = getEventsForDate(day);
                const isPastDate = new Date() > day;
                return (
                  <div
                    key={day.toString()}
                    className={`min-h-16 p-2 border rounded-sm flex flex-col justify-between ${
                      dayEvents.length > 0
                        ? "cursor-pointer hover:bg-gray-200 transition-colors bg-gray-100"
                        : "bg-white"
                    } ${isPastDate ? "opacity-50" : ""} ${
                      selectedDate &&
                      selectedDate.toDateString() === day.toDateString()
                        ? "ring-1 ring-blue-500"
                        : ""
                    }`}
                    onClick={() => handleDateSelection(day)}
                  >
                    <div className="text-right font-medium">
                      {day.getDate()}
                    </div>
                    {dayEvents.length > 0 && (
                      <div className="mt-1 flex flex-wrap gap-1 justify-center">
                        {dayEvents.slice(0, 3).map((event) => (
                          <div
                            key={event.id}
                            className={`w-2 h-2 rounded-full ${event.color}`}
                            title={event.title}
                          ></div>
                        ))}
                        {dayEvents.length > 3 && (
                          <div className="text-xs text-gray-500">
                            +{dayEvents.length - 3}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Event Details */}
        {selectedDate && (
          <div
            ref={eventDetailsRef}
            className="bg-white rounded-md shadow-sm overflow-hidden mb-6"
          >
            <div className="p-6 border-b">
              <h3 className="text-xl font-semibold">
                Events on {formatDate(selectedDate)}
              </h3>
            </div>
            <div className="p-6">
              {getEventsForDate(selectedDate).length === 0 ? (
                <p className="text-gray-500">
                  No events scheduled for this date.
                </p>
              ) : (
                <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
                  {getEventsForDate(selectedDate).map((event) => {
                    const eventStatus = getEventStatus(event);
                    const StatusIcon = eventStatus.icon;
                    return (
                      <div
                        key={event.id}
                        className={`relative rounded-lg overflow-hidden shadow-lg transform transition-transform border-l-4 mx-auto sm:w-11/12 md:w-full ${
                          eventStatus.isPassed
                            ? "border-gray-400"
                            : event.type === "online"
                            ? "border-green-500"
                            : "border-blue-500"
                        }`}
                        style={{
                          background: eventStatus.isPassed
                            ? "linear-gradient(135deg, #f5f5f5, #e0e0e0)"
                            : event.type === "online"
                            ? "linear-gradient(135deg, #e0f2f1, #a5d6a7)"
                            : "linear-gradient(135deg, #e3f2fd, #90caf9)",
                        }}
                      >
                        <div className="w-full h-64 overflow-hidden relative">
                          <img
                            src={event.image}
                            alt={event.title}
                            className={`w-full h-full object-cover object-top rounded-t-lg ${
                              eventStatus.isPassed ? "opacity-50" : ""
                            }`}
                          />
                          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black via-transparent opacity-30 rounded-t-lg"></div>
                        </div>

                        <div className="p-4">
                          <h4 className="text-lg font-semibold text-gray-800 mb-2">
                            {event.title}
                          </h4>
                          <div className="flex items-center mb-2 text-sm text-gray-600">
                            <Calendar className="w-4 h-4 mr-2" />
                            <span>{formatDate(event.date)}</span>
                          </div>
                          <div className="flex items-center mb-2 text-sm text-gray-600">
                            {event.type === "online" ? (
                              <Video className="w-4 h-4 mr-2" />
                            ) : (
                              <MapPin className="w-4 h-4 mr-2" />
                            )}
                            <span>{event.location}</span>
                          </div>
                          <p className="text-sm text-gray-700 mb-4">
                            {event.description}
                          </p>

                          {eventStatus.isPassed && (
                            <p className="text-sm text-red-500 mb-2">
                              {eventStatus.message}
                            </p>
                          )}

                          <button
                            onClick={() => handleEventAction(event)}
                            className={`w-full px-4 py-2 rounded-full text-white font-bold flex items-center justify-center transition-colors ${
                              eventStatus.isPassed
                                ? "bg-gray-400 cursor-not-allowed"
                                : event.type === "online"
                                ? "bg-green-500 hover:bg-green-600"
                                : "bg-blue-500 hover:bg-blue-600"
                            } ${
                              !eventStatus.isPassed && !event.url
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            disabled={eventStatus.isPassed || !event.url}
                          >
                            <StatusIcon className="w-4 h-4 mr-2" />
                            {eventStatus.buttonText}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
